<template>
    <div>
      <v-breadcrumbs class="container" :items="items"></v-breadcrumbs>
      <advanced-search title="Realizar una nueva búsqueda" class-content="border-top border-bottom bg-light" class-body="container" width="100%"></advanced-search>
      <div class="container">
        <h4 class="mb-4">Localizador de Guia</h4>
        <v-app v-if="result == -2">
          <div class="text-center mt-2">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-app>
        <no-result v-else-if="result == 0"></no-result>
        <div class="mb-3" v-else-if="result == 1">
            <client-result :data="data"></client-result>
            <fourth-screen :data="data.InfoTrackingPaquete" :country="data.InfoPaquete[0].Pais"></fourth-screen>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      result: -1,
      items: [
        {
          text: 'Correos',
          link: true,
          exact: true,
          disabled: false,
          to: { name: 'Company' }
        },
        {
          text: 'Localizador',
          link: true,
          exact: true,
          disabled: true,
          to: { name: 'CompanyTracking' }
        }
      ],
      data: {
        InfoPaquete: []
      },
      API: process.env.API
    }
  },
  mounted () {
    this.result = -2
    setTimeout(() => {
      this.$axios({
        url: this.API + this.$route.query.guia,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((resp) => {
          this.data = resp.data
          if (this.data.InfoPaquete.length > 0) {
            this.result = 1
          } else {
            this.result = 0
          }
        })
        .catch((er) => {
          this.result = 0
        })
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/Tracking.vue